import { extractNumbers } from '@/utils/extract-numbers';

export const cnpjMask = (cnpj: string) => {
  const cnpjNumber = extractNumbers(cnpj);
  return cnpjNumber.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};
